/* LES ETOILES SOUS LE TITRE.
 *
 * ⛔⛔ ELLES MONTRENT LA NOTE DE LA BOUTIQUE, ET ELLES SONT SUR TOUTES LES FICHES (Adrien,
 * 28/08/2026 : « affiche les etoiles sous le titre sur tous les produits »).
 * La premiere version affichait la note DU PRODUIT : onze affiches sur seize cents en ont une,
 * et elle y vaut 5,0 partout. Autrement dit, mille cinq cent quatre-vingt-neuf fiches n'avaient
 * rien, et les onze restantes affichaient un chiffre qui ne distingue rien. La note de la
 * boutique, elle, porte tous les avis, vaut pour toutes les fiches, et se lit comme une
 * reputation.
 *
 * ⛔ ELLE VIENT DU MEME RELEVE QUE LE BADGE D'ACHAT, champ `note`. Une seconde source pour un
 * meme chiffre finirait par diverger.
 *
 * ⛔⛔ ET LE LIBELLE ACCESSIBLE LE DIT. Un lecteur d'ecran annoncerait « Note de 4,9 sur 5 »
 * juste apres le nom de l'affiche, ce qui se comprend comme la note DE CETTE AFFICHE. Une
 * phrase differente est donc necessaire, pas seulement un chiffre different.
 *
 * ⛔ ET SUR TELEPHONE, LE CLIC OUVRE UN TIROIR, PAS UNE ANCRE. Adrien : « le clic sur les
 * etoiles ne doit pas pointer vers l'ancre, mais ouvrir les avis depuis un drawer en bas ». Une
 * ancre envoie le lecteur a deux ecrans de la, dans un endroit qu'il n'a pas choisi et d'ou
 * rien ne le ramene ; un tiroir se referme et rend la fiche intacte.
 */
(function () {
  'use strict';
  var h1 = document.querySelector('.pdp-title, .pdp-buy h1, h1');
  /* ⛔⛔ ET PAS DE SECONDE NOTE LA OU LA PAGE EN A DEJA UNE (Adrien, 29/08/2026 : « c'est quoi
     ce bordel ici ? », capture de la fiche B2B). Le garde ne regardait que SA propre classe : la
     page professionnelle porte sa ligne d'etoiles a elle, `[data-b2b-etoiles]`, remplie par
     `b2b.js` depuis Junip et liee au bloc d'avis. Les deux s'affichaient donc cote a cote sous le
     titre, « 4,9/5 » et « 4.94/5 » — la MEME note, arrondie deux fois differemment.
     ⚠️ ON GARDE CELLE DE LA PAGE, pas la sienne : elle porte un lien vers les avis et un nom
     accessible que celle-ci n'a pas. */
  if (!h1 || document.querySelector('.pdp-note, [data-b2b-etoiles]')) return;

  fetch('https://runway.dcomdtf.app/avis-traductions?lang='
    + encodeURIComponent((document.documentElement.getAttribute('lang') || '').toLowerCase()),
  { credentials: 'omit' })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var note = d && d.note;
      /* ⛔ SANS NOTE, RIEN. Une rangee d'etoiles vides se lirait comme « zero ». */
      if (!note) return;

      /* ⛔ LE BLOC DES AVIS EST LE MEME NOEUD, DEPLACE. Le cloner donnerait deux rendus portant
         les memes identifiants et le meme etat de traduction : c'est la faute que ce depot a
         deja faite avec la toile du displate. Le tiroir l'emprunte et le rend. */
      var vers = document.getElementById('avisline');
      var p = document.createElement(vers ? 'a' : 'div');
      p.className = 'pdp-note';
      var total = Number(d.total);
      if (Number.isSafeInteger(total) && total > 0) p.setAttribute('data-review-count', String(total));
      var txt = window.murDeshtml || function (x) { return x; };
      p.setAttribute('aria-label', txt((window.__pdpNoteBoutique || window.__pdpNoteMot || ''))
        .replace('%s', String(note))
        + (vers && window.__pdpAvisTitre ? ' · ' + txt(window.__pdpAvisTitre) : ''));
      if (vers) {
        p.setAttribute('href', '#avisline');
        /* ⛔⛔ PLUS D'ANCRE, SUR AUCUN APPAREIL (Adrien, 28/08/2026 : « sur desktop aussi, ca ne
           doit pas pointer vers l'ancre, mais ouvrir le drawer a droite »). Un saut d'ancre
           depose le lecteur a deux ecrans de la, dans un endroit qu'il n'a pas choisi et d'ou
           rien ne le ramene ; un tiroir se referme et rend la fiche intacte, avec sa taille et
           son cadre deja choisis. C'est la meme raison qui a fait ouvrir le composeur en modale
           plutot qu'en page : sortir de la fiche, c'est perdre la vente.
           ⚠️ LE `href` RESTE, ET CE N'EST PAS DECORATIF : sans JavaScript, sur un Cmd-clic ou un
           clic milieu, le lien mene toujours a la section. On ajoute un geste, on n'en retire
           aucun. */
        p.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          ouvrirTiroir(e, vers);
        });
      } else {
        p.setAttribute('role', 'img');
      }
      var arrondi = Math.round(note);
      for (var i = 1; i <= 5; i += 1) {
        var s = document.createElement('span');
        s.className = 'pdp-note__e' + (i <= arrondi ? ' est-pleine' : '');
        s.textContent = '★';
        s.setAttribute('aria-hidden', 'true');
        p.appendChild(s);
      }
      /* ⛔ LE CHIFFRE PREND LA FORME DU BADGE D'AVIS : gras en encre, « /5 » plus petit et plus
         pale. Deux ecritures pour une meme note se liraient comme deux notes.
         ⚠️ Formate dans la langue de la page — « 4.9 » heurte partout ou la virgule est le
         separateur decimal, dix marches sur treize — et avec UNE decimale toujours : « 5 » se
         lit comme un compte, « 5,0 » comme une note. */
      var chiffre = document.createElement('b');
      chiffre.className = 'pdp-note__val';
      var lang = document.documentElement.getAttribute('lang') || 'fr';
      chiffre.textContent = Number(note).toLocaleString(lang,
        { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      chiffre.setAttribute('aria-hidden', 'true');
      p.appendChild(chiffre);
      h1.insertAdjacentElement('afterend', p);
    })
    .catch(function () { /* pas d'etoiles, pas de bruit */ });

  var tiroir = null;
  var place = null;

  /* ⛔⛔ LE TIROIR EST EXPOSE, ET IL N'Y EN A QU'UN (Adrien, 28/08/2026 : « ici aussi ca doit
     ouvrir le drawer desktop et mobile », a propos du badge sous le bouton d'achat).
     Deux blocs mènent aux avis : les etoiles sous le titre et la note du badge. Ecrire le tiroir
     deux fois donnerait deux panneaux capables de s'ouvrir ensemble, deux endroits ou remettre
     le meme noeud, et deux occasions de diverger. C'est exactement la lecon de `murVersLesAvis`,
     ecrite dans ce depot pour le defilement : le trajet vit a UN SEUL endroit. */
  window.__avisTiroir = function (e) {
    var bloc = document.getElementById('avisline');
    if (!bloc) return false;
    ouvrirTiroir(e, bloc);
    return true;
  };

  function ouvrirTiroir(e, bloc) {
    e.preventDefault();
    if (!tiroir) {
      tiroir = document.createElement('div');
      /* Le cote se decide en CSS, pas ici : c'est une question de largeur d'ecran, et une
         largeur se lit dans une media query, pas dans un script qui devrait la surveiller. */
      tiroir.className = 'avis-tiroir';
      tiroir.setAttribute('role', 'dialog');
      tiroir.setAttribute('aria-modal', 'true');
      tiroir.setAttribute('aria-label', window.__pdpAvisTitre || 'Avis');
      var fond = document.createElement('button');
      fond.type = 'button';
      fond.className = 'avis-tiroir__fond';
      fond.setAttribute('aria-label', window.__pdpAvisFermer || 'Fermer');
      var feuille = document.createElement('div');
      feuille.className = 'avis-tiroir__feuille';
      var croix = document.createElement('button');
      croix.type = 'button';
      croix.className = 'avis-tiroir__croix';
      croix.setAttribute('aria-label', window.__pdpAvisFermer || 'Fermer');
      croix.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">'
        + '<path d="M5 5l10 10M15 5L5 15" fill="none" stroke="currentColor" stroke-width="1.8"'
        + ' stroke-linecap="round"/></svg>';
      var corps = document.createElement('div');
      corps.className = 'avis-tiroir__corps';
      feuille.appendChild(croix);
      feuille.appendChild(corps);
      tiroir.appendChild(fond);
      tiroir.appendChild(feuille);
      document.body.appendChild(tiroir);
      fond.addEventListener('click', fermerTiroir);
      croix.addEventListener('click', fermerTiroir);
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && tiroir && tiroir.hasAttribute('data-ouvert')
            && !document.querySelector('.junip-modal[role="dialog"]')) fermerTiroir();
      }, true);
    }
    /* ⚠️ ON MEMORISE D'OU LE BLOC VIENT AVANT DE LE PRENDRE : sans ce reperage, on ne saurait
       pas ou le remettre, et la page perdrait sa section d'avis a la premiere fermeture. */
    place = { parent: bloc.parentNode, avant: bloc.nextSibling };
    tiroir.querySelector('.avis-tiroir__corps').appendChild(bloc);
    tiroir.setAttribute('data-ouvert', '');
    document.body.classList.add('avis-tiroir-ouvert');
    bloc.dispatchEvent(new CustomEvent('avis:tiroir'));
    var croixEl = tiroir.querySelector('.avis-tiroir__croix');
    if (croixEl) croixEl.focus();
  }

  function fermerTiroir() {
    if (!tiroir || !place) return;
    var bloc = tiroir.querySelector('#avisline');
    if (bloc) place.parent.insertBefore(bloc, place.avant);
    tiroir.removeAttribute('data-ouvert');
    document.body.classList.remove('avis-tiroir-ouvert');
    if (bloc) bloc.dispatchEvent(new CustomEvent('avis:tiroir'));
    var etoiles = document.querySelector('.pdp-note');
    if (etoiles && etoiles.focus) etoiles.focus();
  }
})();
